const allGroups = [
	{
		group: {
			groupId: 0,
			groupName: "Loading data...",
		},
		id: 0,
		user: {
			email: "hello@world.com",
			firstName: "Hello",
			lastName: "World",
			userId: 0,
			username: "Please wait!",
		},
	},
];

export default allGroups;
